import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ManagementEntrySummaryShortModel } from '@data-layer/models/management';
import { enumEntrySummaryState } from '@data-layer/enums/entry-summaries';
import { Observable } from 'rxjs';
import { GenericService } from '@services/generic.service';
import { map } from 'rxjs/operators';

@Component({
  selector: 'es-list-admin',
  templateUrl: './es-list-admin.component.html',
  styleUrls: ['./es-list-admin.component.scss'],
})
export class EsListAdminComponent implements OnInit {
  @Input() public page: number = 1;
  @Input() public esList: Observable<ManagementEntrySummaryShortModel[]>;
  @Input() public isLoading: boolean = false;
  @Input() public total: number;
  @Input() public limit: number;
  @Input() public totalRows: number;
  @Input() public tableId: string | number = 'isf-list-admin';
  @Input() public showCompanyLink: boolean = true;
  @Output() public pageChanged: EventEmitter<number> = new EventEmitter<number>();
  @Output() public limitChanged: EventEmitter<number> = new EventEmitter<number>();

  public enumEntrySummaryState: typeof enumEntrySummaryState = enumEntrySummaryState;
  public paginationMaxSize$: Observable<number>;

  constructor(private genericService: GenericService) {
    this.paginationMaxSize$ = this.genericService.isMobile$.pipe(map((isMobile) => (isMobile ? 5 : 7)));
  }

  public ngOnInit(): void {}

  public onPageChange(page: number) {
    this.page = page;
    this.pageChanged.emit(page);
  }
}
